export default "__VITE_ASSET__D2w2VPqt__"